import React from 'react';

export default function Card({ children, className = '' }) {
    return (
        <div className={`card-header flex-wrap py-2 d-flex align-items-start ${className}`}>
            {children}
        </div>
    )
}